import { createNode } from '@glueapp/graph-types';

export const Logarithm10 = createNode({
    id: 'Logarithm 10',
    name: 'Logarithm 10',
    description: 'Gives the base 10  of the input number',
    aiDescription:
        'Computes the base-10 logarithm of a number. Connect a value to the "Number" input port; the "Logarithm" output port provides the result.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number: { kind: 'number' },
    },
    outPorts: {
        Logarithm: { kind: 'number' },
    },
    execute: function (input) {
        const inputNumber = input.inPorts.Number;
        return { output: { Logarithm: Math.log10(inputNumber) } };
    },
});
